/* eslint-disable @typescript-eslint/naming-convention */
export const ROUTE_PATHS = {
  ADVERTISERS_LIST: "/advertisers",
  ADVERTISER_DETAIL: "/advertisers/:id",
  ADVERTISER_DASHBOARD: "/advertisers/:id/dashboard",
  ADVERTISER_CAMPAIGN_DETAIL: "/advertisers/:advertiserId/campaigns/:campaignId",
  CAMPAIGNS_CREATE: "/campaigns/create",
  MANAGED_CAMPAIGN_CREATE: "/campaigns/create/managed",
  CUSTOM_CAMPAIGN_CREATE: "/campaigns/create/custom",
  CAMPAIGN_CREATE_FROM_TEMPLATE: "/campaigns/create/from-template",
  VISITORS_RE_TARGETING_SEGMENTS: "/visitors-retargeting",
  CRM_RE_TARGETING_SEGMENTS: "/crm-retargeting",
  DASHBOARD: "/dashboard",
  PUBLIC_CAMPAIGNS_PICKER: "/public-campaigns-picker",
  TERMS_PAGE: "/terms-of-use",
  PRIVACY_PAGE: "/privacy-policy",
  ROOT: "/",
  SIGNUP: "/bgsignup",
  FORGOT_PASSWORD: "/request-password-reset",
  ALLBILLINGLOGS: "/allbillinglogs",
  INVOICES: "/invoices",
  PUBLICATION_LISTS: "/publication-lists",
  ZIP_CODES: "/zip-codes",
  ADS_UPLOAD: "/ads-upload",
  TARGET_COMPANIES: "/target-companies",
  ROLES_AND_TITLES: "/roles-titles",
  STATE_PROVINCE: "/state-province",
  SEGMENTS_LOGS: "/segments-logs",
  CAMPAIGN_TEMPLATES: "/campaign-templates",
  CAMPAIGN_TEMPLATE_EDIT: "/campaign-templates/edit/:id",
  CREATE_CAMPAIGN_TEMPLATE: "/create-campaign-template",
  TRADITIONAL_ABM_CREATE: "/campaigns/create/traditional-abm",
  CONTEXTUAL_ABM_CREATE: "/campaigns/create/contextual-abm",
  CONTEXTUAL_MEDIA_BUYING_CREATE: "/campaigns/create/contextual-media-buying",
  CONTEXTUAL_PERSONA_CREATE: "/campaigns/create/contextual-persona",
  GEO_TARGETING_CREATE: "/campaigns/create/geo-targeting",
  CRM_RETARGETING_CREATE: "/campaigns/create/crm-retargeting",
  SITE_RETARGETING_CREATE: "/campaigns/create/site-retargeting",
  PERSONA_RETARGETING_CREATE: "/campaigns/create/persona-retargeting",
};
